import { useTheme } from '@mui/material';

import {
  BAR_BORDER_RADIUS,
  HEIGHT,
} from 'shared/components/charts/BarChart/constants';
import { useChartContext } from 'shared/components/charts/BarChart/hooks';

import type { FC } from 'react';
import type { DataPoint as BarProps } from 'shared/components/charts/BarChart/types';

export const BarFilled: FC<BarProps> = ({ x, y = 0 }) => {
  const { xScale, yScale } = useChartContext();
  const theme = useTheme();

  return (
    <rect
      x={xScale(x)}
      y={yScale(y)}
      width={xScale.bandwidth()}
      height={HEIGHT - yScale(y)}
      fill={theme.palette.deepPurple.accent}
      rx={BAR_BORDER_RADIUS}
    />
  );
};
